/* MUNA PETWEAR · product.js — variantes, compra y ambiente de la página de producto */
(() => {
  const M = window.MUNA || {};
  const S = M.strings || {};

  function init(pdp) {
    if (pdp.dataset.ready) return;
    pdp.dataset.ready = '1';

    // Ambiente: elementos del estampado en la portada
    const motifs = (pdp.dataset.motifs || '').split('|').filter(Boolean);
    const rots = (pdp.dataset.motifRot || '0|0|0').split('|').map(Number);
    const hero = pdp.querySelector('.pdp-hero');
    pdp.querySelectorAll('[data-pdp-motifs] span').forEach((s, i) => {
      if (!motifs.length) { s.hidden = true; return; }
      s.style.setProperty('--motif-img', `url("${motifs[i % motifs.length]}")`);
      const r = rots[i % rots.length] || 0;
      if (r) s.style.setProperty('--r', `${r + (i % 2 ? 12 : -12)}deg`);
    });
    if (hero) requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-in')));

    // Variantes
    const form = pdp.querySelector('[data-product-form]');
    if (!form) return;
    const variants = JSON.parse(pdp.querySelector('[data-variants]')?.textContent || '[]');
    const idInput = form.querySelector('[data-variant-input]');
    const priceEl = pdp.querySelector('[data-price]');
    const stockEl = pdp.querySelector('[data-stock]');
    const addBtn = form.querySelector('[data-add]');
    const addLabel = form.querySelector('[data-add-label]');
    const errorEl = form.querySelector('[data-error]');
    const addText = (addBtn && addBtn.dataset.label) || S.addToCart || 'Agregar al carrito';
    const fieldsets = [...form.querySelectorAll('[data-option-index]')];
    const wa = form.querySelector('[data-wa-order]');
    const waLabel = wa && wa.querySelector('[data-wa-label]');
    let currentVariant = null;

    // Pedido por WhatsApp: diseño, talla, cantidad, precio y link
    function updateWa() {
      if (!wa) return;
      const v = currentVariant || findVariant(selected());
      const qtyN = Math.max(1, parseInt(form.querySelector('.qty__input')?.value, 10) || 1);
      const ok = !!(v && v.available);
      wa.classList.toggle('is-disabled', !ok);
      wa.setAttribute('aria-disabled', String(!ok));
      if (waLabel) waLabel.textContent = ok ? (S.orderWhatsapp || 'Pedir por WhatsApp') : (S.soldOut || 'Agotado');
      if (!v) return;
      const opts = fieldsets.map((fs, i) => `${fs.querySelector('legend')?.textContent.trim() || 'Opción'} ${v.options[i]}`).join(', ');
      const price = M.formatMoney ? M.formatMoney(v.price * qtyN) : '';
      const url = wa.dataset.productUrl + '?variant=' + v.id;
      const text = `Hola MUNA, quiero pedir:\n• ${wa.dataset.productTitle}${opts ? ' – ' + opts : ''} × ${qtyN} (${price})\n${url}`;
      wa.href = `https://wa.me/${wa.dataset.waNumber}?text=${encodeURIComponent(text)}`;
    }

    const selected = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));

    function markAvailability() {
      const opts = selected();
      fieldsets.forEach((fs, i) => {
        fs.querySelectorAll('input').forEach((inp) => {
          const test = [...opts]; test[i] = inp.value;
          const v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      const v = findVariant(selected());
      errorEl.hidden = true;
      currentVariant = v;
      updateWa();
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = S.unavailable || 'No disponible';
        stockEl.textContent = S.unavailable || 'No disponible'; stockEl.dataset.available = 'false';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = M.formatMoney ? M.formatMoney(v.price) : v.price;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addText : (S.soldOut || 'Agotado');
      stockEl.textContent = v.available ? (S.inStock || 'Disponible') : (S.soldOut || 'Agotado');
      stockEl.dataset.available = String(v.available);
      if (history.replaceState) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      markAvailability();
    }
    form.addEventListener('change', (e) => { if (e.target.matches('[data-option-index] input')) update(); if (e.target.matches('.qty__input')) updateWa(); });
    markAvailability();
    currentVariant = findVariant(selected()) || variants.find((v) => String(v.id) === idInput.value);
    updateWa();

    // Cantidad
    const qty = form.querySelector('.qty__input');
    form.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qty));
      updateWa();
    }));

    // Agregar al carrito sin salir de la página
    form.addEventListener('submit', async (e) => {
      if (!M.addToCart) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      errorEl.hidden = true;
      try {
        await M.addToCart(new FormData(form));
        addLabel.textContent = S.added || 'Agregado';
        addBtn.classList.add('is-added');
        setTimeout(() => { addBtn.classList.remove('is-added'); if (!addBtn.disabled) addLabel.textContent = addText; }, 1600);
        M.openCart && M.openCart();
      } catch (err) {
        errorEl.textContent = err.message || S.error;
        errorEl.hidden = false;
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });

    // La guía de tallas elige la talla y vuelve al botón de compra
    document.addEventListener('muna:select-size', (e) => {
      const wanted = String(e.detail.size || '').trim().toLowerCase();
      let found = false;
      fieldsets.forEach((fs) => {
        fs.querySelectorAll('input').forEach((inp) => {
          if (inp.value.trim().toLowerCase() === wanted) { inp.checked = true; found = true; }
        });
      });
      if (found) update();
      const target = form.closest('.pdp-buy');
      target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      setTimeout(() => form.querySelector('input:checked, [data-wa-order], [data-add]')?.focus({ preventScroll: true }), 500);
    });
  }

  const boot = () => document.querySelectorAll('[data-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
